import { render, staticRenderFns } from "./bigScreen.vue?vue&type=template&id=d3a59ffa&scoped=true"
import script from "./bigScreen.vue?vue&type=script&lang=js"
export * from "./bigScreen.vue?vue&type=script&lang=js"
import style0 from "./bigScreen.vue?vue&type=style&index=0&id=d3a59ffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a59ffa",
  null
  
)

export default component.exports